import { userAddressApi as api } from './userAddressApi';
export const addTagTypes = ['UserAddresses', 'UserDetails'] as const;
const injectedRtkApi = api
  .enhanceEndpoints({
    addTagTypes
  })
  .injectEndpoints({
    endpoints: build => ({
      updateBillingAddress: build.mutation<
        UpdateBillingAddressApiResponse,
        UpdateBillingAddressApiArg
      >({
        query: queryArg => ({
          url: `/billingAddress/${queryArg.id}`,
          method: 'PUT',
          body: queryArg.updateUserAddress
        }),
        invalidatesTags: ['UserAddresses']
      }),
      userDetailsByUserId: build.query<
        UserDetailsByUserIdApiResponse,
        UserDetailsByUserIdApiArg
      >({
        query: queryArg => ({
          url: `/userDetails`,
          params: { userId: queryArg.userId, type: queryArg['type'] }
        }),
        providesTags: ['UserDetails']
      })
    }),
    overrideExisting: false
  });
export { injectedRtkApi as enhancedApi };
export type UpdateBillingAddressApiResponse =
  /** status 200 The UserAddress's Billing details has been updated successfully */ {
    ok?: boolean;
    data?: UserBillingAddressType;
    message?: string;
  };
export type UpdateBillingAddressApiArg = {
  /** ID of the UserAddress to update */
  id: string;
  /** UserAddress that needs to be added to the application */
  updateUserAddress: UpdateUserAddress;
};
export type UserDetailsByUserIdApiResponse =
  /** status 200 UserDetails details found. */ {
    ok?: boolean;
    data?: UserDetails;
    message?: string;
  };
export type UserDetailsByUserIdApiArg = {
  /** ID of the UserDetails to retrieve */
  userId?: string;
  /** Address Type */
  type?: string;
};
export type UserBillingAddressType = string;
export type UpdateUserAddress = {
  line1?: string;
  line2?: string;
  city?: string;
  state?: string;
  postal_code?: string;
  type?: string;
  contactNumber?: string;
  country?: string;
  status?: string;
  firstName?: string;
  lastName?: string;
};
export type UserDetails = {
  id: string;
  userId: string;
  profileImage: string;
  stripeCustomerId: string;
  firstName: string;
  lastName: string;
  dateOfBirth: string;
  status: string;
  createdAt: string;
  updatedAt: string;
  email: string;
  line1: string;
  line2: string;
  city: string;
  state: string;
  postal_code: string;
  country: string;
  type: string;
  contactNumber: string;
};
export const { useUpdateBillingAddressMutation, useUserDetailsByUserIdQuery } =
  injectedRtkApi;
